import { render, staticRenderFns } from "./AdminMenuComponent.html?vue&type=template&id=0ed4251a&scoped=true&"
import script from "./AdminMenuComponent.js?vue&type=script&lang=js&"
export * from "./AdminMenuComponent.js?vue&type=script&lang=js&"
import style0 from "./AdminMenuComponent.scss?vue&type=style&index=0&id=0ed4251a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed4251a",
  null
  
)

export default component.exports